import { useContextStore } from "@/store/context";
// Interceptors nécessitant une intéraction avec le store
export default defineNuxtPlugin(({ $apiDrive, $pinia }) => {
  const contextStore = useContextStore($pinia);
  const headers = process.server ? useRequestHeaders() : null;

  $apiDrive.setRequestInterceptor((config) => {
    if (process.server) {
      if (headers["app-partner"]) {
        contextStore.setAppPartner(headers["app-partner"]);
      }
    }

    if (contextStore.isVip) {
      config.headers["test-vip"] = "true";
    }

    config.headers.uuid = contextStore.uuid;

    return config;
  });
});
